/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import PDatePicker from "../../components/pos/PDatePicker";
import PSelect from "../../components/pos/PSelect";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import { StringUtils } from "../../utils/StringUtils";
import SaleInsight from "./SaleInsight";

export default function AnalyticsHome(props) {
  const { t } = useTranslation();
  const translate = t;
  const [reports, setReports] = useState({});

  const [mainReportOptions, setMainReportOptions] = useState([]);
  const [mainReport, setMainReport] = useState();

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [defaultEndDate, setDefaultEndDate] = useState();

  const [showStartDate, setShowStartDate] = useState(false);
  const [showEndDate, setShowEndDate] = useState(false);

  const [enableGenerate, setEnableGenerate] = useState(false);
  const [showAdvancedView, setShowAdvanceView] = useState(false);
  const [generateButtonLabel, setGenerateButtonLabel] = useState("Generate");
  const [reportData, setReportData] = useState([]);
  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    let { data } = await API.get("/report/available");
    setReports(data);
    //console.log(data);
    let mainMenuOption = [];
    for (var key in data) {
      if (key == "analytics") {
        console.log(data[key]);
        for (let rpt of data[key].children) {
          if (rpt.config) {
            mainMenuOption.push({
              id: rpt,
              name: rpt.config.label,
            });
          }
        }
      }
    }
    setMainReportOptions(mainMenuOption);
  }

  function mainReportChanged(value) {
    resetParams();
    setMainReport(value);

    if (value) {
      setEnableGenerate(true);
      //let config = getSelectedReportConfig(value);
      let config = value.id.config;
      if (value.id.config.paramList) {
        for (var param of config.paramList) {
          if (param.key === "startDate") {
            let dt = getDate(param);
            setShowStartDate(true);
            setStartDate(StringUtils.formatDate(dt, 2));
          }
          if (param.key === "endDate") {
            let dt = getDate(param);
            setShowEndDate(true);
            setEndDate(StringUtils.formatDate(dt, 2));
          }
        }
      }
    }
  }

  function getDate(param) {
    //console.log(param);
    if (param.defaultValue) {
      if (param.defaultValue === "startOfMonth") {
        let dt = new Date();
        return new Date(dt.getFullYear(), dt.getMonth(), 1);
      } else if (param.defaultValue === "endOfMonth") {
        let dt = new Date();

        return new Date(
          dt.getFullYear(),
          dt.getMonth(),
          this.daysInMonth(dt.getMonth() + 1, dt.getFullYear())
        );
      } else if (param.defaultValue === "today") {
        return new Date();
      }
    } else {
      return new Date();
    }
  }
  function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  function resetParams() {
    setShowStartDate(false);
    setShowEndDate(false);
    setEnableGenerate(false);
    setShowAdvanceView(false);
  }

  async function onGenerateReport() {
    setGenerateButtonLabel(translate("Generating"));
    console.log(mainReport);
    setEnableGenerate(false);

    let reportReq = {
      template: mainReport.id.name,
      rawData: true,
      paramList: [],
    };

    if (showStartDate) {
      console.log(startDate);
      reportReq.paramList.push({
        key: "startDate",
        value: startDate,
      });
    }

    if (showEndDate) {
      reportReq.paramList.push({
        key: "endDate",
        value: endDate,
      });
    }

    try {
      let { data } = await API.post("/report/generate", reportReq);
      setReportData(data.d);
    } catch (e) {
      setGenerateButtonLabel(translate("Generate"));
      setEnableGenerate(true);
    }

    setGenerateButtonLabel(translate("Generate"));
    setEnableGenerate(true);
  }

  return (
    <Grid container style={{ height: "100vh" }}>
      <Grid item xs={12} style={{ height: "36px" }}>
        <Grid container>
          <Grid item xs={2} style={{ padding: "2px", paddingLeft: 0 }}>
            <PSelect
              options={mainReportOptions}
              value={mainReport}
              onChange={(event, newValue) => {
                setMainReport(newValue);
                mainReportChanged(newValue);
              }}
            ></PSelect>
          </Grid>

          <Grid item xs={2} style={{ padding: "2px", paddingLeft: "10px" }}>
            {showStartDate && (
              <PDatePicker
                value={startDate}
                onChange={(value) => {
                  console.log(value);
                  setStartDate(StringUtils.formatDate(value.$d, 2));
                }}
              ></PDatePicker>
              /*<MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd-MM-yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    //label="Date picker inline"
                    value={startDate}
                    onChange={(value) => {
                      console.log(StringUtils.formatDate(value, 1));
                      setStartDate(StringUtils.formatDate(value, 2));
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>*/
            )}
          </Grid>
          <Grid item xs={2} style={{ padding: "2px", paddingLeft: "10px" }}>
            {showEndDate && (
              <PDatePicker
                value={endDate}
                onChange={(value) =>
                  setEndDate(StringUtils.formatDate(value.$d, 2))
                }
              ></PDatePicker>
            )}
          </Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={3} style={{ padding: "2px" }}></Grid>
          <Grid item xs={1}>
            <Button
              style={{ marginRight: 10 }}
              variant="contained"
              color="primary"
              disabled={!enableGenerate}
              onClick={onGenerateReport}
            >
              {generateButtonLabel}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ height: "100%" }}>
        <SaleInsight data={reportData}></SaleInsight>
      </Grid>
    </Grid>
  );
}
